import Price from "../types/Price";

export const isZero = (price: Price): boolean => parseFloat(price.value) === 0;
